import { bootcamp } from "./bootcamp";
import { degree } from "./degree";
import { execed } from "./execed";

type Monarch = {
  [lob: string]: {
    sourceId: string;
    clientToken: string;
    overrides?: {
      [school: string]: {
        [program: string]: {
          sourceId: string;
          clientToken: string;
        };
      };
    };
  };
};

type Make = {
  [lob: string]: {
    [school: string]: {
      [program: string]: {
        sourceKey: string;
        writeKey: string;
        oneTrust?: string;
        gtagId?: string;
        segmentId?: string;
        mobius?: {
          apiKey: string;
          domain: string;
        };
      };
    };
  };
};

type Cohesion = {
  development: {
    monarch: Monarch;
    make: Make;
  };
  production: {
    monarch: Monarch;
    make: Make;
  };
};

const cohesion: Cohesion = {
  development: {
    monarch: {
      bootcamp: {
        sourceId: "7d119098-fd33-4bfa-9018-16a9432c03ea",
        clientToken: "980bef00-3a2e-4039-8290-32bfbac3bdd5",
      },
      degree: {
        sourceId: "5c25827f-f4ed-466a-a357-f2ce6cbd6c15",
        clientToken: "fb720bef-a21f-420a-ab3e-3749cf9ff0f8",
      },
      execed: {
        sourceId: "31db677c-bed6-4e2c-81f0-ce958930edff",
        clientToken: "002e5825-94f2-49f1-8f34-8754e3e305a6",
      },
    },
    make: {
      bootcamp: {
        school: {
          program: {
            sourceKey: "src_2jvQDVEJb1mA1LP3sAoTJ7xQieq",
            writeKey: "wk_2jvQDR9ucrjIacDsM9xT1Szg7AC",
          },
        },
      },
      degree: {
        school: {
          program: {
            sourceKey: "src_2jvQJbEl5vLU07K0CkLcvqPa2or",
            writeKey: "wk_2jvQJZVHhSIVsXk1qe6d7YMT9Y7",
          },
        },
      },
      execed: {
        school: {
          program: {
            sourceKey: "src_2jvQLoJiCOIqmrqzrms9FhCQPiC",
            writeKey: "wk_2jvQLus5SdBJKz85E4tjy4opEFJ",
          },
        },
      },
    },
  },
  production: {
    monarch: {
      bootcamp: {
        sourceId: "40c0f68a-4d89-4438-adae-5749ac8c023a",
        clientToken: "77a3c69c-ac5b-42f1-861f-6651348dbe2c",
        overrides: {
          cu: {
            cybersecurity: {
              sourceId: "0c8114ee-7031-47d7-a9fc-db3fc48909e9",
              clientToken: "bffe2bf3-1b17-4e9f-8157-1113eab4e221",
            },
          },
        },
      },
      degree: {
        sourceId: "f65bc305-59b5-4b34-9e57-931af581ad3c",
        clientToken: "9177b509-73ea-4ebb-b1e2-a385ef2c73ab",
        overrides: {
          ucb: {
            data: {
              sourceId: "c4bcf7c3-8d50-4faa-8335-a19fc918e90c",
              clientToken: "55f0bb23-687c-4506-80e3-64adf9777058",
            },
          },
        },
      },
      execed: {
        sourceId: "565ce432-0cc9-4e7d-a45f-e12286a83078",
        clientToken: "2ae15445-91c8-494b-97f3-495ae7b266ed",
        overrides: {
          mit: {
            "ai-stra": {
              sourceId: "174169d3-e4e3-49b1-bd3e-e13a0c638627",
              clientToken: "d655afdb-b570-49e9-b9fa-28918b667e24",
            },
          },
        },
      },
    },
    make: {
      bootcamp,
      degree,
      execed,
    },
  },
};

export default cohesion[process.env.NEXT_ENV as "development" | "production"] || cohesion.development;
